import { render } from "./liquidationNew.vue?vue&type=template&id=0988cf4e&scoped=true"
import script from "./liquidationNew.vue?vue&type=script&lang=js"
export * from "./liquidationNew.vue?vue&type=script&lang=js"

import "./liquidationNew.vue?vue&type=style&index=0&id=0988cf4e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0988cf4e"]])

export default __exports__